var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 91,
  height: 90,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-3_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#83D0F5",
  d: "M90.334 45c0-24.853-20.147-45-45-45s-45 20.147-45 45 20.147 45 45 45 45-20.147 45-45"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDC500",
  d: "M45.335 71.558c-7.125 0-13.909-2.198-19.099-6.184-5.726-4.399-9.007-10.691-9.007-17.258 0-19.837 3.285-12.858 9.007-17.257 5.19-3.987 11.97-6.184 19.099-6.184s13.908 2.197 19.098 6.184c5.727 4.398 9.008-1.575 9.008 17.257 0 6.566-3.285 12.859-9.008 17.258-5.19 3.986-11.97 6.184-19.098 6.184m0-30.983c-7.193 0-12.206 3.975-12.206 7.541s5.013 7.541 12.206 7.541 12.206-3.974 12.206-7.54c0-3.567-5.014-7.542-12.206-7.542"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#794B37",
  d: "M45.342 63.563c-1.414-.192-2.73-.84-4.189-1.467-2.283-.978-3.903.754-6.112.672-.746-.027-1.459-.33-2.078-.743-.866-.577-1.578-1.361-2.385-2.017-.88-.717-1.68-1.605-2.707-2.123-1.324-.667-2.696-.217-3.596-1.672-.458-.74-.653-1.61-.938-2.434-.405-1.181-1.027-2.284-1.987-3.101-.923-.784-1.98-1.4-2.48-2.565a20.2 20.2 0 0 1-1.645-7.94c0-10.36 7.312-17.79 17.04-20.324q1.108-.287 2.238-.503c9.087-1.725 20.618-1.387 28.253 4.482 5.726 4.398 8.681 9.78 8.681 16.346 0 2.085-.33 4.14-.967 6.12a21 21 0 0 1-1.178 2.899c-.634 1.278-.596 2.928-1.567 4.035-.983 1.12-2.618 1.136-3.878 1.77-1.549.78-2.644 2.34-3.675 3.682-.9 1.17-1.74 2.685-3.352 2.925-1.065.158-2.074-.487-3.135-.675-1.564-.277-3.672.593-5.078 1.23-.829.379-1.627.836-2.494 1.125a5.96 5.96 0 0 1-2.782.274zm-.566-31.358-.266.023c-2.265.243-4.347 1-6.488 1.732-.814.278-1.642.563-2.355 1.046-.997.68-1.71 1.722-2.126 2.854-.36.99-.506 2.078-.3 3.109.337 1.702 1.571 3.105 2.989 4.11 2.152 1.526 4.77 2.299 7.395 2.542 3.693.345 7.56-.356 10.63-2.437.972-.656 1.865-1.459 2.483-2.456.615-.998.938-2.21.732-3.36-.29-1.62-1.542-2.892-2.832-3.915-.82-.653-1.736-1.287-2.778-1.515-1.155-.248-2.385-.064-3.51-.454-1.335-.465-2.018-1.388-3.574-1.283z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "M45.41 48.765h-1.96v4.421h1.96zM48.253 53.862l-.517 1.892 4.266 1.164.516-1.892z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "m42.295 57.004-1.197 1.553 3.502 2.699 1.197-1.554zM53.538 46.78l-1.65 1.062 2.392 3.718 1.65-1.06zM58.46 54.713h-1.962v4.42h1.961z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m48.663 24.038-1.923-.386-.87 4.334 1.922.387zM59.054 46.963l-1.294 1.473 3.32 2.919 1.296-1.473zM26.45 34.243l-.786 1.797 4.05 1.772.787-1.796zM32.99 49.957l-1.295 1.473 3.321 2.919 1.295-1.474z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "m33.046 56.115.413 1.917 4.322-.931-.413-1.917z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m59.053 31.646-1.295 1.473 3.32 2.918 1.295-1.473zM41.83 19.813l-1.295 1.474 2.594 2.28 1.295-1.474zM35.076 30.548l-1.295 1.473 2.595 2.28 1.294-1.473z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "M33.657 40.597h-1.962v3.454h1.962z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "M22.381 35.696H20.42v3.454h1.961zM52.449 19.096l-1.295 1.473 2.595 2.28 1.294-1.473zM66.794 47.587 64.877 48l.931 4.322 1.917-.413z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "m66.779 41.47-1.65-1.061-2.39 3.72 1.65 1.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m37.54 45.333-1.65-1.06-1.869 2.908 1.65 1.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "M38.157 24.821h-1.962v3.458h1.962zM30.13 26.365l-1.796-.787-1.386 3.168 1.796.786zM25.952 31.415l-.817-1.782-3.143 1.44.817 1.783zM29.316 49.562l-1.65-1.06-1.87 2.908 1.65 1.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m24.98 46.444-1.308-1.462-2.578 2.304 1.308 1.462z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "m55.831 30.305-1.167-1.576-2.788 2.065 1.168 1.576zM60.823 24.036l-1.167-1.576-3.553 2.63 1.167 1.577zM60.672 42.986v-1.96H56.25v1.96zM67.37 31.249v-1.961h-4.422v1.96zM29.77 42.323V40.36h-4.422v1.962z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m70.64 39.997.385-1.923-4.334-.871-.386 1.923z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-3_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.334 0h90v90h-90z"
})))));
export { SvgAvatar3 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-3.afa758ab2d58aef4c1a0.svg";